<div class="filter-modal-container">
  <div class="filter-header">Filters</div>
  <div class="filter-container">
    <ng-container *ngIf="openForm">
      <form [formGroup]="VendorFilterForm" class="filter-form">
        <ng-container>
          <emerald-dropdown
            [label]="'Project Name'"
            [outlined]="true"
            [showFilter]="true"
            [isValid]="true"
            formControlName="project"
            [options]="projectOptions"
            [id]="'project_select'"
            [preSelectedLabel]="'label'"
            [preSelectedValue]="'value'"
          >
          </emerald-dropdown>

          <emerald-dropdown
            [label]="'Reporting Manager'"
            [outlined]="true"
            [showFilter]="true"
            [isValid]="true"
            formControlName="reportingManager"
            [options]="reportingManagerOptions"
            [id]="'reporting_manager_select'"
            [preSelectedLabel]="'label'"
            [preSelectedValue]="'value'"
          >
          </emerald-dropdown>

          <emerald-dropdown
            [label]="'D&T Leader'"
            [outlined]="true"
            [showFilter]="true"
            [isValid]="true"
            formControlName="dntLeader"
            [options]="dntLeaderOptions"
            [id]="'dnt_leader_select'"
            [preSelectedLabel]="'label'"
            [preSelectedValue]="'value'"
          >
          </emerald-dropdown>

          <emerald-dropdown
            [label]="'Employee Status'"
            [outlined]="true"
            [showFilter]="true"
            [isValid]="true"
            formControlName="employeeStatus"
            [options]="employeeStatusOptions"
            [id]="'employee_status_select'"
            [preSelectedLabel]="'label'"
            [preSelectedValue]="'value'"
          >
          </emerald-dropdown>

          <emerald-dropdown
            [outlined]="true"
            [id]="'status_select'"
            [label]="'Status'"
            formControlName="status"
            [options]="timesheetStatusOptions"
            [preSelectedLabel]="'label'"
            [preSelectedValue]="'value'"
          ></emerald-dropdown>
        </ng-container>
      </form>
    </ng-container>
    <ng-container actions>
      <div class="button-container">
        <span class="mdc-dialog__button">
          <emerald-button
            [label]="'Reset'"
            [type]="'Secondary'"
            (onClick)="reset()"
          ></emerald-button>
        </span>
        <span class="mdc-dialog__button">
          <emerald-button
            [label]="'Apply'"
            [type]="'Primary'"
            (onClick)="apply()"
          ></emerald-button>
        </span>
      </div>
    </ng-container>
  </div>
</div>
